import SmoothScroll from "../components/SmoothScroll";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import KineticMarquee from "../components/Marquee";
import Services from "../components/Services";
import Manifesto from "../components/Manifesto";
import Gallery from "../components/Gallery";
import BookingSection from "../components/BookingSection";
import QuoteForm from "../components/QuoteForm";
import Footer from "../components/Footer";
import VisitTracker from "../components/VisitTracker";
import InstallPWA from "../components/InstallPWA";

export default function PublicSite() {
  return (
    <SmoothScroll>
      <div className="min-h-screen bg-[#050505] text-white">
        <VisitTracker />
        <Navbar />
        <main>
          <Hero />
          <KineticMarquee />
          <Services />
          <Manifesto />
          <Gallery />
          <BookingSection />
          <QuoteForm />
        </main>
        <Footer />
        <InstallPWA />
      </div>
    </SmoothScroll>
  );
}
